import { Table } from "@mantine/core";
import { HeldEmailSelectionModel } from "./heldEmailSelection";
import { HeldEmailQueueSelectAll } from "./HeldEmailQueueSelectAll";

interface Props {
  selection: HeldEmailSelectionModel;
}

export function HeldEmailQueueTableHeader({ selection }: Props) {
  return (
    <Table.Thead>
      <Table.Tr>
        <Table.Th>
          <HeldEmailQueueSelectAll selection={selection} />
        </Table.Th>
        <Table.Th>Email</Table.Th>
        <Table.Th>Recipient</Table.Th>
        <Table.Th>Case</Table.Th>
        <Table.Th>Status</Table.Th>
        <Table.Th>Captured</Table.Th>
        <Table.Th>Actions</Table.Th>
      </Table.Tr>
    </Table.Thead>
  );
}
